import { render, staticRenderFns } from "./coin.vue?vue&type=template&id=30d2c77e&"
import script from "./coin.vue?vue&type=script&lang=js&"
export * from "./coin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d2c77e')) {
      api.createRecord('30d2c77e', component.options)
    } else {
      api.reload('30d2c77e', component.options)
    }
    module.hot.accept("./coin.vue?vue&type=template&id=30d2c77e&", function () {
      api.rerender('30d2c77e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/coin.vue"
export default component.exports